import React, { Component } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { values, filter } from 'lodash';


export class TableWaterBalanceRealLoss extends Component {
  constructor(props) {
    super();


  }

  colspanCriteria = (cell, row, rowIndex, colIndex) => {
    if (rowIndex !== 8 && rowIndex !== 10 && rowIndex !== 11) {
      return { colSpan: `3` }
    }
  }

  hiddenColCriteria = (cell, row, rowIndex, colIndex) => {
    if (rowIndex !== 8 && rowIndex !== 10 && rowIndex !== 11) {
      return { hidden: true }
    }
  }

  formatCellForUnitCol = (cell, row) => {
    if (row.name === 'Total Number of Connections' || row.name === 'Total Length of Mains' || row.name === 'Average Pressure') {
      return (<span>{cell}</span>)
    }
    else if (row.name === 'WATER SUPPLIED TO THIS SYSTEM') {
      return (<span><strong>m<sup>3</sup></strong>/day</span>)
    } else if (row.name === 'NON-REVENUE WATER (NRW)' || row.name === 'WATER LOSSES' ||
      row.name === 'APPARENT LOSSES (Commercial)' || row.name === 'CURRENT ANNUAL REAL LOSSES (CARL)' || row.name === 'UNAVOIDABLE ANNUAL REAL LOSSES (UARL)' ||
      row.name === 'POTENTIALLY RECOVERABLE REAL LOSSES = (CARL - UARL)') {
      return (<span><strong>m<sup>3</sup>/day</strong></span>)
    } else if (row.name === 'Billed Metered Consumption') {
      return (<span>m<sup>3</sup>/day</span>)
    } else if (row.name === 'Billed Unmetered Consumption (AVERAGE READING)' ||
      row.name === 'Unbilled Authorised Consumption' || row.name === 'Unauthorised Consumption (Illegal)' ||
      row.name === 'Customer Metering Inaccuracies') {
      return (<span>m<sup>3</sup>/day</span>)
    } else if (row.name === 'Percent NRW') {
      return (<span><strong>{cell}</strong></span>)
    }
    return (<span>{cell}</span>)
  }

  formatCellForNameCol = (cell, row) => {
    if (row.name === 'WATER SUPPLIED TO THIS SYSTEM' || row.name === 'NON-REVENUE WATER (NRW)' || row.name === 'Percent NRW' || row.name === 'WATER LOSSES' ||
      row.name === 'APPARENT LOSSES (Commercial)' || row.name === 'CURRENT ANNUAL REAL LOSSES (CARL)' || row.name === 'UNAVOIDABLE ANNUAL REAL LOSSES (UARL)' ||
      row.name === 'POTENTIALLY RECOVERABLE REAL LOSSES = (CARL - UARL)' || row.name === 'Infrastructure Leakage Index (ILI)') {
      return (<span><strong>{cell}</strong></span>)
    }

    return (<span>{cell}</span>)
  }

  formatCellForValueCol = (cell, row) => {
    if (row.name === 'WATER SUPPLIED TO THIS SYSTEM' || row.name === 'NON-REVENUE WATER (NRW)' || row.name === 'Percent NRW' || row.name === 'WATER LOSSES' ||
      row.name === 'APPARENT LOSSES (Commercial)' || row.name === 'CURRENT ANNUAL REAL LOSSES (CARL)' || row.name === 'UNAVOIDABLE ANNUAL REAL LOSSES (UARL)' ||
      row.name === 'POTENTIALLY RECOVERABLE REAL LOSSES = (CARL - UARL)' || row.name === 'Infrastructure Leakage Index (ILI)') {
      return (<span><strong>{cell}</strong></span>)
    }
    return (<span>{cell}</span>)
  }

  styleNameCol = (cell, row, rowIndex, colIndex) => {
    let rowsIndex = [3, 6, 7, 9, 12, 13, 14, 15, 16];
    if (rowsIndex.includes(rowIndex)) {
      return {
        backgroundColor: '#C5F0B4'
      };
    }
  }

  styleValueCol = (cell, row, rowIndex, colIndex) => {
    let rowsIndex = [0, 1, 2, 3, 4, 5];
    if (rowsIndex.includes(rowIndex)) {
      return {
        backgroundColor: '#FFF0A3'
      };
    }
  }

  stylePercentCol = (cell, row, rowIndex, colIndex) => {
    let rowsIndex = [8, 10, 11];
    if (rowsIndex.includes(rowIndex)) {
      return {
        backgroundColor: '#FFF0A3'
      };
    }
  }

  reorder = (sources, indexs) => {
    try {
      let temp = new Array(sources.length);

      // arr[i] should be present at index[i] index 
      for (let i = 0; i < sources.length; i++)
        temp[indexs[i]] = sources[i];

      // Copy temp[] to arr[] 
      for (let i = 0; i < sources.length; i++) {
        sources[i] = temp[i];
        indexs[i] = i;
      }
      return sources;

    } catch (error) {
      console.log('Error in reorder real loss:', error);
    }
  }

  createProduct = (dataNRWByDMA) => {
    try {
      let newObject = {};
      for (let key in dataNRWByDMA) {
        newObject[key] = key;
      }
      // console.log('newObject',newObject);
      let arrayKey = values(newObject);
      // console.log('array v: ', arrayKey);

      let products = arrayKey.map((key) => {
        let oneObject = {}
        // console.log('key.toLowerCase()',key.toLowerCase());
        switch (key.toLowerCase()) {
          case 'total_connections':
            oneObject = { dmaid: 'total_connections', name: 'Total Number of Connections', percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: 'nos' }
            break;
          case 'total_length':
            oneObject = { dmaid: 'total_length', name: 'Total Length of Mains', percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: 'km' }
            break;
          case 'average_pressure':
            oneObject = { dmaid: 'average_pressure', name: 'Average Pressure', percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: 'm' }
            break;
          case 'water_supplied':
            oneObject = { dmaid: 'water_supplied', name: 'WATER SUPPLIED TO THIS SYSTEM', percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: 'm3/day' }
            break;
          case 'bill_meter_consump':
            oneObject = { dmaid: 'bill_meter_consump', name: 'Billed Metered Consumption', percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: 'm3/day' }
            break;
          case 'bill_unmeter_consump':
            oneObject = { dmaid: 'bill_unmeter_consump', name: 'Billed Unmetered Consumption (AVERAGE READING)', percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: 'm3/day' }
            break;
          case 'non_rev_water_nrw':
            oneObject = { dmaid: 'non_rev_water_nrw', name: 'NON-REVENUE WATER (NRW)', percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: 'm3/day' }
            break;
          case 'percent_nrw':
            oneObject = { dmaid: 'percent_nrw', name: 'Percent NRW', percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: '%' }
            break;
          case 'unbill_auth_consump':
            oneObject = { dmaid: 'unbill_auth_consump', name: 'Unbilled Authorised Consumption', percent: `${dataNRWByDMA['PER_UNBILL_AUTH_CONS']}`, des_percent: '% of Water Supplied', value: `${dataNRWByDMA[key]}`, unit: 'm3/day' }
            break;
          case 'water_losses':
            oneObject = { dmaid: 'water_losses', name: 'WATER LOSSES', percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: 'm3/day' }
            break;
          case 'unauth_consump':
            oneObject = { dmaid: 'unauth_consump', name: 'Unauthorised Consumption (Illegal)', percent: `${dataNRWByDMA['PER_UNAUTH_CONS']}`, des_percent: '% of Water Supplied', value: `${dataNRWByDMA[key]}`, unit: 'm3/day' }
            break;
          case 'cus_meter_inaccura':
            oneObject = { dmaid: 'cus_meter_inaccura', name: 'Customer Metering Inaccuracies', percent: `${dataNRWByDMA['PER_METER_INACCURA']}`, des_percent: '% of Billed Metered Consumption', value: `${dataNRWByDMA[key]}`, unit: 'm3/day' }
            break;
          case 'app_losses':
            oneObject = { dmaid: 'app_losses', name: 'APPARENT LOSSES (Commercial)', percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: 'm3/day' }
            break;
          case 'cur_an_real_loss':
            oneObject = { dmaid: 'cur_an_real_loss', name: 'CURRENT ANNUAL REAL LOSSES (CARL)', percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: 'm3/day' }
            break;
          case 'unavo_an_real_loss':
            oneObject = { dmaid: 'unavo_an_real_loss', name: 'UNAVOIDABLE ANNUAL REAL LOSSES (UARL)', percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: 'm3/day' }
            break;
          case 'pot_reco_real_loss':
            oneObject = { dmaid: 'pot_reco_real_loss', name: 'POTENTIALLY RECOVERABLE REAL LOSSES = (CARL - UARL)', percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: 'm3/day' }
            break;
          case 'infras_leakage_index':
            oneObject = { dmaid: 'infras_leakage_index', name: 'Infrastructure Leakage Index (ILI)', percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: '' }
            break;
          default:
            oneObject = { dmaid: `${key}`, name: false, percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: '' }

          // code block
        }

        // console.log('oneobject',oneObject);
        return oneObject;
      });

      // console.log('products d',products);

      let optimizeProducts = filter(products, (o) => {
        // console.log('o.name: ',o.name);
        return o.name
      });

      // console.log('optimizeProducts d',optimizeProducts);

      let indexs = [0, 1, 3, 2, 4, 5, 8, 10, 11, 6, 7, 9, 12, 13, 14, 15, 16];

      //order element by order in index
      let finalOutput = this.reorder(optimizeProducts, indexs);

      return finalOutput;
    } catch (error) {
      console.log('Error in create product: ', error);
    }
  }

  render() {
    const columns = [
      {
        dataField: 'dmaid',
        text: 'DMA ID',
        hidden: true
      }, {
        dataField: 'name',
        text: 'IWA WATER BALANCE',
        headerAttrs: { colSpan: '5' },
        attrs: this.colspanCriteria,
        formatter: this.formatCellForNameCol,
        style: this.styleNameCol
      }, {
        dataField: 'percent',
        text: 'Percent Value',
        attrs: this.hiddenColCriteria,
        headerAttrs: { hidden: true },
        style: this.stylePercentCol
      }, {
        dataField: 'des_percent',
        text: 'Description of percent',
        attrs: this.hiddenColCriteria,
        headerAttrs: { hidden: true }
      }, {
        dataField: 'value',
        text: 'Value',
        headerAttrs: { hidden: true },
        formatter: this.formatCellForValueCol,
        style: this.styleValueCol
      }, {
        dataField: 'unit',
        text: 'Unit',
        headerAttrs: { hidden: true },
        formatter: this.formatCellForUnitCol
      }];
    const products_default = [
      { dmaid: 'total_connections', name: 'Total Number of Connections', percent: '', des_percent: '', value: '0', unit: 'nos' },
      { dmaid: 'total_length', name: 'Total Length of Mains', percent: '', des_percent: '', value: '0', unit: 'km' },
      { dmaid: 'average_pressure', name: 'Average Pressure', percent: '', des_percent: '', value: '0', unit: 'm' },
      { dmaid: 'water_supplied', name: 'WATER SUPPLIED TO THIS SYSTEM', percent: '', des_percent: '', value: '0', unit: 'm3/day' },
      { dmaid: 'bill_meter_consump', name: 'Billed Metered Consumption', percent: '', des_percent: '', value: '0', unit: 'm3/day' },
      { dmaid: 'bill_unmeter_consump', name: 'Billed Unmetered Consumption (AVERAGE READING)', percent: '', des_percent: '', value: '0', unit: 'm3/day' },
      { dmaid: 'non_rev_water_nrw', name: 'NON-REVENUE WATER (NRW)', percent: '', des_percent: '', value: '0', unit: 'm3/day' },
      { dmaid: 'percent_nrw', name: 'Percent NRW', percent: '', des_percent: '', value: '0', unit: '%' },
      { dmaid: 'unbill_auth_consump', name: 'Unbilled Authorised Consumption', percent: '0', des_percent: '% of Water Supplied', value: '0', unit: 'm3/day' },
      { dmaid: 'water_losses', name: 'WATER LOSSES', percent: '', des_percent: '', value: '0', unit: 'm3/day' },
      { dmaid: 'unauth_consump', name: 'Unauthorised Consumption (Illegal)', percent: '0', des_percent: '% of Water Supplied', value: '0', unit: 'm3/day' },
      { dmaid: 'cus_meter_inaccura', name: 'Customer Metering Inaccuracies', percent: '0', des_percent: '% of Billed Metered Consumption', value: '0', unit: 'm3/day' },
      { dmaid: 'app_losses', name: 'APPARENT LOSSES (Commercial)', percent: '', des_percent: '', value: '0', unit: 'm3/day' },
      { dmaid: 'cur_an_real_loss', name: 'CURRENT ANNUAL REAL LOSSES (CARL)', percent: '', des_percent: '', value: '0', unit: 'm3/day' },
      { dmaid: 'unavo_an_real_loss', name: 'UNAVOIDABLE ANNUAL REAL LOSSES (UARL)', percent: '', des_percent: '', value: '0', unit: 'm3/day' },
      { dmaid: 'pot_reco_real_loss', name: 'POTENTIALLY RECOVERABLE REAL LOSSES = (CARL - UARL)', percent: '', des_percent: '', value: '0', unit: 'm3/day' },
      { dmaid: 'infras_leakage_index', name: 'Infrastructure Leakage Index (ILI)', percent: '', des_percent: '', value: '0', unit: '' },
    ]

    

    let products = this.createProduct(this.props.dataNRWByDMA);
    // console.log('array tam: ', products);
    if (products.length === 0) {
      // console.log('here length = 0');
      products = products_default;
    }

    return (
      // style={{overflowY:'auto',height: '350px'}}
      <div >
        <BootstrapTable keyField='dmaid' data={products} columns={columns} wrapperClasses="table-responsive" version='4' />
      </div>
    )
  }
}

export default TableWaterBalanceRealLoss
